"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = Radio;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _HorizontalFlex = require("../containers/HorizontalFlex");

var _PadContainer = require("../containers/PadContainer");

var _Label = require("../typography/Label");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Radio(props) {
  if (props.label) {
    return /*#__PURE__*/_react["default"].createElement(_HorizontalFlex.HorizontalFlex, null, /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({}, props, {
      color: "default"
    })), /*#__PURE__*/_react["default"].createElement(_PadContainer.PadContainer, {
      cssClassModifiers: ['pad-small']
    }, /*#__PURE__*/_react["default"].createElement(_Label.Label, {
      disabled: props.disabled
    }, props.label)));
  }

  return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({}, props, {
    color: "default"
  }));
}

Radio.propTypes = {
  label: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  disabled: _propTypes["default"].bool
};
Radio.defaultProps = {
  disabled: false
};